/*
# -----------------------------------------------------------------------------
# Component: debitNoteListMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 10/May/2019
# Comments: Responsible for all data table related functionality
# -----------------------------------------------------------------------------
*/
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export const debitNoteListMixin = {
  data() {
    return {
      totalItems: 0,
      items: [],
      selectedPage: 0,
      selectedDebitNoteColumns: ['branch', 'accountNo', 'documentNo', 'tranDate', 'currency', 'amount', 'gst'],
      debitNoteColumns: [
        { text: 'Branch', value: 'branch' },
        { text: 'Acct. No.', value: 'accountNo' },
        { text: 'Doc. No.', value: 'documentNo' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Currency', value: 'currency' },
        { text: 'Amount ', value: 'amount' },
        { text: 'GST', value: 'gst' }
      ],
      firstTimeCalling: true
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listDbHeaders() {
      let result = []
      for (const selectedDbColumn of this.selectedDebitNoteColumns) {
        let findCol = this.debitNoteColumns.find(a => selectedDbColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    'pagination': function (value) {
      if (this.firstTimeCalling === false) {
        this.performSearch(false)
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
